export default __webpack_public_path__ + "static/media/icon-location.f11c5487.svg";